export default defineNuxtRouteMiddleware(async (to, from) => {
    /**
     * These are the allowed paths to which we can redirect from the oauth flow.
     */
    const ALLOWED_PATHS = ["/login", '/login/', "/login/select-oauth", '/login/select-oauth/'];

    // We use the includes with the fixed paths because if /login/example is the current path, it will be ok, but it should redirect to /login
    if (!ALLOWED_PATHS.includes(from.path)) {
      return navigateTo("/login");
    }
    return;
});
